import { Alert } from 'antd';
import { styled } from 'styled-components';

interface StyledAlertProps {
  fullWidth?: boolean;
}

export const StyledAlert = styled(Alert)<StyledAlertProps>`
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  font-size: 14px;
  width: ${props => (props.fullWidth ? '100%' : 'fit-content')};

  &.ant-alert-success {
    background-color: ${props => props.theme.colors.success.light.surfaceBg};
    border-color: ${props => props.theme.colors.success.light.border};

    .ant-alert-message {
      color: ${props => props.theme.colors.success.main.text};
    }

    .ant-alert-description {
      color: ${props => props.theme.colors.success.main.text};
    }

    .ant-alert-icon {
      color: ${props => props.theme.colors.success.main.icon};
    }
  }

  &.ant-alert-info {
    background-color: ${props => props.theme.colors.info.light.surfaceBg};
    border-color: ${props => props.theme.colors.info.light.border};

    .ant-alert-message {
      color: ${props => props.theme.colors.info.main.text};
    }

    .ant-alert-description {
      color: ${props => props.theme.colors.info.main.text};
    }

    .ant-alert-icon {
      color: ${props => props.theme.colors.info.main.icon};
    }
  }

  &.ant-alert-warning {
    background-color: ${props => props.theme.colors.warning.light.surfaceBg};
    border-color: ${props => props.theme.colors.warning.light.border};

    .ant-alert-message {
      color: ${props => props.theme.colors.warning.main.text};
    }

    .ant-alert-description {
      color: ${props => props.theme.colors.warning.main.text};
    }

    .ant-alert-icon {
      color: ${props => props.theme.colors.warning.main.icon};
    }
  }

  &.ant-alert-error {
    background-color: ${props => props.theme.colors.error.light.surfaceBg};
    border-color: ${props => props.theme.colors.error.light.border};

    .ant-alert-message {
      color: ${props => props.theme.colors.error.main.text};
    }

    .ant-alert-description {
      color: ${props => props.theme.colors.error.main.text};
    }

    .ant-alert-icon {
      color: ${props => props.theme.colors.error.main.icon};
    }
  }
`;
